
import ErrorLayout from "@soenergy/frontend-library/src/components/ErrorLayout"

export default {
  layout: "error",
  components: {
    ErrorLayout
  },
  props: {
    error: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    layoutVariant() {
      if (this.error.statusCode === 404) {
        return "notFoundError"
      }
      return "generic"
    }
  },
  methods: {
    navigatedAway() {
      this.$analytics.sendEvent({
        area: "404",
        name: "Click on Go to Homepage link"
      })
    }
  }
}
